import {
  CardContainer,
  CompPagination,
  Container,
  ModalMergeTicket,
} from "components";
import React, {
  useEffect,
  useState,
  Fragment,
  useRef,
  useCallback,
  useContext,
} from "react";
import { BiSortDown, BiSortUp } from "react-icons/bi";
import { RiGitMergeLine, RiAttachment2 } from "react-icons/ri";
import { TbArrowsExchange } from "react-icons/tb";
import {
  FaCheck,
  FaComment,
  FaFacebook,
  FaGlobe,
  FaHandPointRight,
  FaPhone,
  FaTelegram,
  FaTwitter,
  FaUserEdit,
  FaWindowClose,
} from "react-icons/fa";
import { Menu, Transition } from "@headlessui/react";
import { AiOutlineCaretDown, AiOutlineMail } from "react-icons/ai";
import { IoPeople } from "react-icons/io5";
import { slicingWord } from "utils/slicingWord";
import { BsTrashFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  API_URL_deleteBatchTicket,
  API_URL_ticket,
  API_URL_updateBatchTicket,
} from "constants/api";
import { ticketReducers } from "redux/ticketSlice";
import useDebounce from "hooks/useDebounce";
import { getData } from "actions";
import { PulseLoader, SyncLoader } from "react-spinners";
import moment from "moment";
import { toast } from "react-toastify";
import axios from "axios";
import ModalAssignBatch from "components/molecules/ModalAssignBatch";
import { AuthContext } from "context/AuthContext";
import Swal from "sweetalert2";
import { encodeBase64 } from "utils/baseEnamEmpat";
import { ticketInboxReducers } from "redux/ticketInboxSlice";

// field for use sort up/down
const TABLE_HEAD = [
  { title: "Subjek", field: "" },
  { title: "ID Ticket", field: "ticket_number" },
  { title: "From", field: "client_name" },
  { title: "Email", field: "user_email" },
  { title: "Department", field: "dept" },
  { title: "Assigned to", field: "assigned_to" },
  { title: "Created", field: "created_at" },
  { title: "Last Activity", field: "updated_at" },
];

const TicketUnassigned = () => {
  const [checkAll, setCheckAll] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [previewVisible, setPreviewVisible] = useState({});
  const {
    datauser,
    wsTotalTicket,
    updateCountTicket,
    setUpdateCountTicket,
    updateNotification,
    setUpdateNotification,
  } = useContext(AuthContext);
  const scrollContainerRef = useRef(null);

  //jika typeTicket ada maka assign jika tidak kosong
  let typeTicketParam = "";
  if (datauser !== "") {
    typeTicketParam = `type=unassigned&agent=${datauser.id}`;
  }

  //data ticket per halaman
  const [DataTicket, setDataTicket] = useState([]);
  //data ticket lengkap yang telah di choice saat merge
  const [choiceTicketInMerge, setChoiceTicketInMerge] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingMerge, setLoadingMerge] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [openModalAssignBatch, setOpenModalAssignBatch] = useState(false);
  const [openModalMerge, setOpenModalMerge] = useState(false);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const nowDatetime = new Date();

  //button fixed
  const [isSticky, setIsSticky] = useState(false);
  const scrollY = useSelector((state) => state.scroll.scrollY);
  const openNavbar = useSelector((state) => state.openNavbar.open);

  const {
    getUnassignedResult,
    getUnassignedLoading,
    getUnassignedError,
    addUnassignedResult,
    deleteUnassignedResult,
  } = useSelector((state) => state.ticketInbox);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_ticket,
        params,
        { dispatch, redux: ticketInboxReducers },
        "GET_UNASSIGNED"
      );
    },
    [dispatch]
  );

  const handlePageClick = ({ selected }) => {
    const newOffset = selected * limit;
    const params = `?${typeTicketParam}&limit=${limit}&offset=${newOffset}&search=${search}&ordering=${
      sortOrder === "desc" ? "-" : ""
    }${sortColumn}`;
    setOffset(newOffset);
    setCurrentPage(selected);
    get(params);
  };

  const delayedSearch = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffset(0);
      setCurrentPage(0);
      setDataTicket([]);

      const params = `?${typeTicketParam}&limit=${limit}&offset=${offset}&search=${value}&ordering=${
        sortOrder === "desc" ? "-" : ""
      }${sortColumn}`;
      get(params);
    }, 1000),
    [limit, offset, sortOrder, sortColumn, typeTicketParam]
  );

  const onSearch = (value) => {
    setSearch(value);
    delayedSearch(value);
  };

  const handleSort = (column) => {
    //RESET PAGINATE KE 1
    setOffset(0);
    setCurrentPage(0);
    setDataTicket([]);

    if (column === sortColumn) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  // Sort icons
  const renderSortIcon = (field) => {
    if (field === sortColumn) {
      return sortOrder === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };

  const handleSelectLimit = (limit) => {
    //RESET PAGINATE KE 1
    setOffset(0);
    setCurrentPage(0);
    setDataTicket([]);

    const params = `?${typeTicketParam}&limit=${limit}&offset=${offset}&search=${search}&ordering=${
      sortOrder === "desc" ? "-" : ""
    }${sortColumn}`;
    get(params);
    setLimit(limit);
  };

  const alertPermissionRestricted = () => {
    toast.warning("Sorry, you don't have permission to perform this action.", {
      position: "top-center",
      autoClose: true,
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const fetchData = useCallback(() => {
    if (typeTicketParam !== "") {
      const params = `?${typeTicketParam}&limit=${limit}&offset=${offset}&search=${search}&ordering=${
        sortOrder === "desc" ? "-" : ""
      }${sortColumn}`;
      get(params);
      setCheckedItems([]);
      setCheckAll(false);
    }
  }, [
    get,
    limit,
    offset,
    sortColumn,
    sortOrder,
    typeTicketParam,
    wsTotalTicket,
  ]);

  // Function for checking all checkboxes
  const handleCheckAllChange = (e) => {
    setCheckAll(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < getUnassignedResult.results?.length; i++) {
        index.push(getUnassignedResult.results[i]?.id);
      }
      const allItems = index;
      setCheckedItems(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItems([]);
    }
  };

  // Function for checking one item
  const handleCheckboxChange = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItems([...checkedItems, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItems.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItems(updatedItems);
    }
  };

  //function to handle open preview
  const HandleOpenPreviewSubject = (id) => {
    setPreviewVisible((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };
  const HandleClosePreviewSubject = (id) => {
    setPreviewVisible((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };

  //funtion to handle
  const HandleAssign = () => {
    // Have permission can Assign ticket ?
    const permission = datauser.group_permissions;
    const canAssignTicket = permission.includes("can_assign_ticket");
    if (!canAssignTicket) {
      alertPermissionRestricted();
    } else {
      setOpenModalAssignBatch(true);
    }
  };

  const HandleCloseAssign = () => {
    setOpenModalAssignBatch(false);
  };

  const HandlePreviewUser = (id) => {
    navigate(`/users/userdirectory/view`, {
      state: {
        item: {
          id,
        },
      },
    });
  };

  const HandleNotSpam = () => {
    if (checkedItems.length === 0) {
      toast.warning("Please choose the ticket ", {
        position: "top-center",
        autoClose: true,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      Swal.fire({
        title: "Are You Sure?",
        text: "These tickets are not spam ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#378ecc",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        customClass: {
          container: "z-[99999]",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let dataUpdate = [];
          checkedItems.map((item, index) => {
            const data = {
              id: item,
              is_spam: 0,
              by_user: datauser.id,
            };
            dataUpdate.push(data);
          });
          axios({
            headers: {
              Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
            },
            method: "POST",
            data: { updates: dataUpdate },
            url: API_URL_updateBatchTicket,
          })
            .then((response) => {
              setLoadingStatus(false);
              setUpdateCountTicket(!updateCountTicket);
              toast.success("Update Ticket Not Spam Successfully", {
                position: "top-center",
                autoClose: true,
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              fetchData();
            })
            .catch((error) => {
              setLoadingStatus(false);
              console.log(error);
              fetchData();
            });
        }
      });
    }
  };

  const HandleDeleteTicketBatch = () => {
    // Have permission can delete ticket ?
    const permission = datauser.group_permissions;
    const canDeleteTicket = permission.includes("can_delete_ticket");
    if (!canDeleteTicket) {
      alertPermissionRestricted();
    } else {
      if (checkedItems.length === 0) {
        toast.warning("Please choose the ticket ", {
          position: "top-center",
          autoClose: true,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        Swal.fire({
          title: "Are You Sure?",
          text: "The record will be delete permanent",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#378ecc",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          customClass: {
            container: "z-[99999]",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            axios({
              method: "POST",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
              },
              data: { ids: checkedItems },
              url: API_URL_deleteBatchTicket,
              timeout: 120000,
            })
              .then((response) => {
                setUpdateCountTicket(!updateCountTicket);
                Swal.fire({
                  icon: "success",
                  title: "The record has been removed",
                  customClass: {
                    container: "z-[99999]",
                  },
                  text: response.data.messages,
                  showConfirmButton: false,
                  timer: 1500,
                });
                setUpdateNotification(!updateNotification);
                fetchData();
              })
              .catch((error) => {
                if (error.response.data && error.response.status !== 500) {
                  // Jika respons mengandung data objek, tampilkan sebagai daftar
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    customClass: {
                      container: "z-[99999]",
                    },
                    html: `
                  <div>
                  <ul>
                    ${Object.entries(error.response.data)
                      .map(([key, value]) => `<li>${value}</li>`)
                      .join("")}
                  </ul>
                </div>
                `,
                  });
                } else {
                  // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.message,
                  });
                }
              });
          }
        });
      }
    }
  };

  const HandleCloseMerge = () => {
    setOpenModalMerge(false);
  };

  const HandleMerge = () => {
    setLoadingMerge(true);
    if (checkedItems.length === 0 || checkedItems.length === 1) {
      setLoadingMerge(false);
      toast.warning("Please choose ticket minimal 2 ", {
        position: "top-center",
        autoClose: true,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      const ChoiceTicket = [];

      //get data tiket lengkap berdasarkan id yang dicheck
      checkedItems.forEach((item, index) => {
        const dataChoiceTicket = DataTicket.filter((val) => item === val.id);
        if (dataChoiceTicket.length > 0) {
          ChoiceTicket.push(dataChoiceTicket[0]);
        }
      });

      // Pertama, ambil user ID dari objek pertama (jika ada)
      const referenceUserId =
        ChoiceTicket.length > 0 ? ChoiceTicket[0].user : null;
      // Kemudian, periksa setiap objek dalam array
      const allObjectsHaveSameUser = ChoiceTicket.every(
        (item) => item.user === referenceUserId
      );

      // Jika semua objek memiliki user yang sama
      if (allObjectsHaveSameUser) {
        setLoadingMerge(false);

        //set data ticket yang telah dipilih
        setChoiceTicketInMerge(ChoiceTicket);

        //melakukan open modal
        setOpenModalMerge(true);
      } else {
        // Batalkan tindakan karena ada perbedaan user di antara objek-objek
        setLoadingMerge(false);
        toast.warning("Please select tickets with the same sender", {
          position: "top-center",
          autoClose: true,
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  const HandleOpen = () => {
    if (checkedItems.length === 0) {
      toast.warning("Please choose the ticket ", {
        position: "top-center",
        autoClose: true,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setLoadingStatus(true);

      let dataUpdate = [];
      checkedItems.map((item, index) => {
        const data = {
          id: item,
          status: 1,
          closed: 0,
          reopened: 1,
          by_user: datauser.id,
        };
        dataUpdate.push(data);
      });
      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: { updates: dataUpdate },
        url: API_URL_updateBatchTicket,
      })
        .then((response) => {
          setLoadingStatus(false);
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Opened Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          fetchData();
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
          fetchData();
        });
    }
  };

  const HandleClose = () => {
    // Have permission can Close ticket ?
    const permission = datauser.group_permissions;
    const canCloseTicket = permission.includes("can_close_ticket");
    if (!canCloseTicket) {
      alertPermissionRestricted();
    } else {
      if (checkedItems.length === 0) {
        toast.warning("Please choose the ticket ", {
          position: "top-center",
          autoClose: true,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setLoadingStatus(true);

        let dataUpdate = [];
        checkedItems.map((item, index) => {
          const data = {
            id: item,
            status: 3,
            closed: 1,
            reopened: 0,
            by_user: datauser.id,
          };
          dataUpdate.push(data);
        });
        axios({
          headers: {
            Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
          },
          method: "POST",
          data: { updates: dataUpdate },
          url: API_URL_updateBatchTicket,
        })
          .then((response) => {
            setLoadingStatus(false);
            setUpdateCountTicket(!updateCountTicket);
            toast.success("Ticket Closed Successfully", {
              position: "top-center",
              autoClose: true,
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            fetchData();
          })
          .catch((error) => {
            setLoadingStatus(false);
            console.log(error);
            fetchData();
          });
      }
    }
  };

  const HandleResolved = () => {
    if (checkedItems.length === 0) {
      toast.warning("Please choose the ticket ", {
        position: "top-center",
        autoClose: true,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setLoadingStatus(true);

      let dataUpdate = [];
      checkedItems.map((item, index) => {
        const data = {
          id: item,
          status: 2,
          closed: 0,
          reopened: 0,
          by_user: datauser.id,
        };
        dataUpdate.push(data);
      });
      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: { updates: dataUpdate },
        url: API_URL_updateBatchTicket,
      })
        .then((response) => {
          setLoadingStatus(false);
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Resolved Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          fetchData();
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
          fetchData();
        });
    }
  };

  const HandleDeleted = () => {
    // Have permission can delete ticket ?
    const permission = datauser.group_permissions;
    const canDeleteTicket = permission.includes("can_delete_ticket");
    if (!canDeleteTicket) {
      alertPermissionRestricted();
    } else {
      if (checkedItems.length === 0) {
        toast.warning("Please choose the ticket ", {
          position: "top-center",
          autoClose: true,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setLoadingStatus(true);
        let dataUpdate = [];
        checkedItems.map((item, index) => {
          const data = {
            id: item,
            status: 4,
            closed: 0,
            reopened: 0,
            by_user: datauser.id,
          };
          dataUpdate.push(data);
        });
        axios({
          headers: {
            Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
          },
          method: "POST",
          data: { updates: dataUpdate },
          url: API_URL_updateBatchTicket,
        })
          .then((response) => {
            setLoadingStatus(false);
            setUpdateCountTicket(!updateCountTicket);
            toast.success("Ticket Deleted Successfully", {
              position: "top-center",
              autoClose: true,
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            fetchData();
          })
          .catch((error) => {
            setLoadingStatus(false);
            console.log(error);
            fetchData();
          });
      }
    }
  };

  useEffect(() => {
    if (scrollY > 200) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  });

  useEffect(() => {
    if (datauser !== "") {
      fetchData();
    }
  }, [datauser]);

  useEffect(() => {
    setOffset(0);
    setCurrentPage(0);
  }, [typeTicketParam]);

  useEffect(() => {
    fetchData();
  }, [sortColumn, sortOrder, typeTicketParam, wsTotalTicket]);

  useEffect(() => {
    if (addUnassignedResult) {
      fetchData();
    }
  }, [addUnassignedResult, fetchData]);

  useEffect(() => {
    if (deleteUnassignedResult) {
      fetchData();
    }
  }, [deleteUnassignedResult, fetchData]);

  useEffect(() => {
    if (getUnassignedResult.results) {
      if (Array.isArray(getUnassignedResult.results)) {
        // Filter out existing data from getUnassignedResult before merging
        const newData = getUnassignedResult.results.filter(
          (item) =>
            !DataTicket.some((existingItem) => existingItem.id === item.id)
        );

        if (newData.length > 0) {
          const updatedData = [...DataTicket, ...newData];
          setDataTicket(updatedData);
        }
      }
    }
  }, [getUnassignedResult]);

  return (
    <Container>
      <CardContainer title={"Unassigned"}>
        <div className={`p-4`} ref={scrollContainerRef}>
          <div
            className={`text-sm flex gap-2 items-center ${
              isSticky
                ? "fixed bg-neutral-300 dark:bg-neutral-700 z-10 p-2 rounded"
                : ""
            }
            ${openNavbar ? "top-28" : "top-16"}`}
          >
            <button
              onClick={HandleMerge}
              title="Merge two or more tickets that are the same"
              className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-emerald-500"
            >
              {loadingMerge ? (
                <PulseLoader color="rgb(16 185 129)" size={11} />
              ) : (
                <RiGitMergeLine />
              )}
              Merge
            </button>

            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button
                  title="Change status ticket"
                  className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-primary-500"
                >
                  {loadingStatus ? (
                    <PulseLoader color="#4477CE" size={11} />
                  ) : (
                    <TbArrowsExchange />
                  )}
                  Change Status
                  <AiOutlineCaretDown
                    className="-mr-1 h-3 w-3 text-gray-400"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    <Menu.Item>
                      <button
                        onClick={() => HandleOpen()}
                        className="block w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                      >
                        Open
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        onClick={() => HandleResolved()}
                        className="block w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                      >
                        Resolved
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        onClick={() => HandleClose()}
                        className="block w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                      >
                        Closed
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        onClick={() => HandleDeleted()}
                        className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100 text-gray-900"
                      >
                        Deleted
                      </button>
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>

            {checkedItems.length > 0 && (
              <>
                <button
                  onClick={HandleAssign}
                  title="Assign ticket to agent"
                  className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border text-black bg-neutral-50 hover:bg-neutral-100"
                >
                  <FaHandPointRight className="text-black" /> Assign
                </button>
              </>
            )}
          </div>
        </div>

        {/* button perpage and input search  */}
        <div className="flex flex-col md:flex-row md:justify-between align-middle px-4 mb-4 bg-neutral dark:bg-neutral-800 ">
          <div className="p-1 inline-block align-middle">
            <select
              id="limit"
              value={limit}
              onChange={(e) => handleSelectLimit(e.target.value)}
              className="border rounded-sm p-1 border-gray-300 dark:text-black focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
            <span className="mx-2 text-sm ">Records per page</span>
          </div>
          <div className="p-1 inline-block align-middle">
            <span className="text-sm mr-2">Search:</span>
            <input
              id="search"
              type="text"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search ..."
              className="p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
        </div>

        {/* note indikator */}
        <div className="flex flex-wrap gap-5 mb-2 text-xs px-4">
          <div className="flex items-center">
            <div className="border-l-4 border-sky-300 pl-1">New Ticket</div>
          </div>
          <div className="flex items-center">
            <div className="border-l-4 border-red-500 pl-1">
              Replied back by the User
            </div>
          </div>
          <div className="flex items-center">
            <div className="border-l-4 border-green-500 pl-1">
              Answered by the Agent
            </div>
          </div>
        </div>

        {/* table and pagination */}
        <div className="mx-4 ">
          <div className="overflow-y-hidden min-h-[55vh]">
            <table className="w-full border-collapse border">
              <thead className="text-left">
                <tr className="">
                  <th className="p-2 border border-gray-300">
                    <input
                      id="checkbox-table"
                      type="checkbox"
                      className="form-checkbox w-4 h-4 ml-[1.5px]"
                      checked={checkAll}
                      onChange={handleCheckAllChange}
                    />
                  </th>
                  {TABLE_HEAD.map((item, itemIdx) => (
                    <th
                      key={itemIdx}
                      className="p-2 border text-sm whitespace-nowrap cursor-pointer"
                      onClick={() => {
                        item.field && handleSort(item.field);
                      }}
                    >
                      <span className="flex">
                        {item.title}
                        {item.field && renderSortIcon(item.field)}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="text-left text-sm">
                {/* loading  */}
                {getUnassignedLoading && (
                  <tr>
                    <td
                      className="text-center py-12"
                      colSpan={TABLE_HEAD.length + 1}
                    >
                      <div className="pt-10 pb-6 flex justify-center items-center">
                        <SyncLoader color="#4477CE" />
                      </div>
                    </td>
                  </tr>
                )}
                {/* Error */}
                {getUnassignedError && (
                  <tr>
                    <td className="text-center" colSpan={TABLE_HEAD.length + 1}>
                      <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                        {getUnassignedError}
                      </div>
                    </td>
                  </tr>
                )}
                {/* Result = 0 */}
                {Array.isArray(getUnassignedResult.results) &&
                  getUnassignedResult.results.length === 0 && (
                    <tr>
                      <td
                        className="text-center"
                        colSpan={TABLE_HEAD.length + 1}
                      >
                        <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                          No Data
                        </div>
                      </td>
                    </tr>
                  )}

                {Array.isArray(getUnassignedResult.results) &&
                  getUnassignedResult.results.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className={`border-b border-l-4 bg-gray-50 dark:bg-neutral-900
                        ${
                          item.isanswered === 1 &&
                          item.last_replier_rolegroup === "agent"
                            ? "border-l-green-500"
                            : item.isanswered === 0 && item.assigned_to === null
                            ? "border-l-blue-300"
                            : item.isanswered === 1 &&
                              item.last_replier_rolegroup === "user"
                            ? "border-l-red-500"
                            : "border-l-blue-300"
                        }
                        `}
                      >
                        <td className="p-2 border">
                          <input
                            id={`checkbox-${item.id}`}
                            type="checkbox"
                            className="form-checkbox w-4 h-4"
                            checked={checkedItems.includes(item.id)}
                            onChange={(e) => handleCheckboxChange(e, item.id)}
                          />
                        </td>
                        <td
                          className="p-2 relative"
                          onMouseEnter={() => {
                            HandleOpenPreviewSubject(item.id);
                          }}
                          onMouseLeave={() => {
                            HandleClosePreviewSubject(item.id);
                          }}
                        >
                          <button
                            className="w-full text-left"
                            disabled={getUnassignedLoading ? true : false}
                          >
                            <Link
                              to={`/tickets/ticketdetail/${encodeBase64(
                                item.id
                              )}`}
                              state={item}
                              className="text-blue-600 hover:text-blue-700 flex items-center"
                            >
                              {`${item.title && slicingWord(item.title, 100)}`}
                            </Link>
                          </button>
                          <div
                            id={`preview-${item.id}`}
                            className={`p-1 h-28 w-80 overflow-auto border bg-white border-gray-300 rounded-lg absolute left-5 md:left-20 lg:left-28 botom-0 z-10 text-center ${
                              previewVisible[item.id] ? "block" : "hidden"
                            }`}
                          >
                            <div className="font-bold text-black">
                              {item.user_email}
                            </div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.body,
                              }}
                              className="mt-2 text-black ck-editor-content"
                            ></div>
                          </div>
                          <div className="flex">
                            <span
                              title={`has ${item.ticket_thread_count_agent} ticket messages `}
                              className="text-green-600"
                            >
                              {`(${item.ticket_thread_count_agent})`}
                            </span>
                            <div>
                              {item.source === 1 && (
                                <FaGlobe
                                  title="Ticket Create From Web"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 2 && (
                                <AiOutlineMail
                                  title="Ticket Create From Email"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 3 && (
                                <FaUserEdit
                                  title="Ticket Create From Agent"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 4 && (
                                <FaFacebook
                                  title="Ticket Create From Facebook"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 5 && (
                                <FaTwitter
                                  title="Ticket Create From Twitter"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 6 && (
                                <FaPhone
                                  title="Ticket Create From Telephone"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 7 && (
                                <FaComment
                                  title="Ticket Create From Chat"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                              {item.source === 8 && (
                                <FaTelegram
                                  title="Ticket Create From Telegram"
                                  className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                />
                              )}
                            </div>
                            <div>
                              {item.ticket_collaborator === 1 && (
                                <IoPeople
                                  title="Ticket Collaborator"
                                  className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                />
                              )}
                            </div>
                            <div>
                              {item.ticket_attachment && (
                                <RiAttachment2
                                  title="Has File Attachment"
                                  className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                />
                              )}
                            </div>

                            {nowDatetime > new Date(item.duedate) ? (
                              <span
                                title="Overdue"
                                className="bg-red-400 text-black dark:bg-neutral-200 rounded  px-1"
                              >
                                Overdue
                              </span>
                            ) : (
                              <span
                                title="Due Today"
                                className="bg-yellow-400 text-black dark:bg-neutral-200 rounded  px-1"
                              >
                                Duetoday
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="p-2 border">
                          <p className="text-blue-800 text-center hover:text-blue-900">
                            {item.ticket_number}
                          </p>
                        </td>
                        <td className="p-2 border text-green-700 dark:text-green-200">
                          <p
                            className="cursor-pointer"
                            onClick={() => HandlePreviewUser(item.user)}
                          >
                            {item.client_name}
                          </p>
                        </td>
                        <td className="p-2 border text-black dark:text-white">
                          {item.user_email}
                        </td>
                        <td className="p-2 border text-black dark:text-white text-center">
                          {item.dept_name ? item.dept_name : "-"}
                        </td>
                        <td className="p-2 border text-center">
                          {item.assigned_to === null && item.team === null ? (
                            <span className="text-red-500">UNASSIGNED</span>
                          ) : (
                            <span
                              onClick={() =>
                                HandlePreviewUser(item.assigned_to)
                              }
                              className="text-green-700 dark:text-green-200 cursor-pointer"
                            >
                              {item.team_name ?? item.assignedto_name}
                            </span>
                          )}
                        </td>
                        <td className="p-2 border text-black dark:text-white">
                          {moment(item.created_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                        </td>
                        <td className="p-2 border text-black dark:text-white">
                          {moment(item.updated_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="pt-5 py-11">
              <CompPagination
                handlePageClick={(e) => handlePageClick(e)}
                pageCount={
                  getUnassignedResult.count > 0 ? getUnassignedResult.count : 0
                }
                limit={limit}
                offset={offset}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>
      </CardContainer>
      <div>
        <ModalAssignBatch
          isOpen={openModalAssignBatch}
          onClose={HandleCloseAssign}
          item={checkedItems}
          callback={() => fetchData()}
        />
        <ModalMergeTicket
          isOpen={openModalMerge}
          onClose={HandleCloseMerge}
          item={choiceTicketInMerge}
          callback={() => fetchData()}
        />
      </div>
    </Container>
  );
};

export default TicketUnassigned;
